<template>
	<div class="onetushow">
		<div class="imgscale" ref="test">
			<img :src="onetuimg" alt="" style="width: 100%;">
		</div>
		<span class="backbtn" @click="closeModel()">返 回</span>
	</div>
</template>

<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';

	export default {
		name: '',
		//import引入的组件需要注入到对象中才能使用
		components: {},
		data() {
			//这里存放数据
			return {
				onetuimg:''
			};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {
			closeModel(){
				this.$router.go(-1)
			}
		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {
			console.log(this.$route.params.url)
			this.onetuimg=this.$route.params.url
		},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {
			if (window.screen.width > 750) {
				console.log("", window.screen.width)
				const html = document.querySelector('html');
				const width = window.screen.width
				html.style.fontSize = width / 13 + 'px'
				this.isbig = true
			}
		},
		beforeCreate() {}, //生命周期 - 创建之前
		beforeMount() {}, //生命周期 - 挂载之前
		beforeUpdate() {}, //生命周期 - 更新之前
		updated() {}, //生命周期 - 更新之后
		beforeDestroy() {}, //生命周期 - 销毁之前
		destroyed() {}, //生命周期 - 销毁完成
		activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
	}
</script>
<style lang="less">
	/* @import url(); 引入公共css类 */
	.onetushow{
		max-width: 7.5rem;
		// position: fixed;
		z-index: 20;
		top: 0;
		margin: 0 auto;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
		// margin-left: -.24rem;
		img{
			width: 100%;
		}
		.backbtn{
			position: fixed;
			z-index: 21;
			top: 0.4rem;
			// right: 0.3rem;
			margin-left: 5.5rem;
			display: block;
			padding: 0.1rem 0.4rem;
			border-radius: 0.3rem;
			background: linear-gradient(to bottom ,#D0E1AA,#45B3B2);
			display: flex;
			justify-content: center;
			align-items: center;
			color: #fff;
			font-weight: bold;
			font-size: 0.34rem;
		}
	}
</style>
